import type { CustomerRole } from 'mmfintech-backend-api/types'
import { isValidString, tr } from 'mmfintech-commons'
import type { UseFilterOutput } from 'mmfintech-commons/types'

export type ExpenseReportsTab =
  // | 'all-reports'
  | 'all-awaiting-approval'
  | 'your-action-needed'
  | 'your-reports'
  | 'concluded'
  | 'awaiting-approval'
  | 'awaiting-payment'
  | 'draft'
  | 'returned'

type ExpenseReportsTabType = {
  name: ExpenseReportsTab
  title: string
}

export const getExpenseReportsTabs = (userPermissions: string[], role: CustomerRole): ExpenseReportsTabType[] => {
  switch (role) {
    case 'STAFF':
      if (userPermissions.includes('APPROVER')) {
        return [
          {
            title: tr('FRONTEND.REPORTS.TABS.ALL_AWAITING_APPROVAL', 'All awaiting approval'),
            name: 'all-awaiting-approval'
          },
          { title: tr('FRONTEND.REPORTS.TABS.YOUR_ACTION_NEEDED', 'Your action needed'), name: 'your-action-needed' },
          { title: tr('FRONTEND.REPORTS.TABS.YOUR_REPORTS', 'Your reports'), name: 'your-reports' },
          { title: tr('FRONTEND.REPORTS.TABS.AWAITING_PAYMENT', 'Awaiting payment'), name: 'awaiting-payment' },
          { title: tr('FRONTEND.REPORTS.TABS.CONCLUDED', 'Concluded'), name: 'concluded' }
        ]
      }
      if (userPermissions.includes('SUBMITTER')) {
        return [
          { title: tr('FRONTEND.REPORTS.STATUSES.AWAITING_APPROVAL', 'Awaiting approval'), name: 'awaiting-approval' },
          { title: tr('FRONTEND.REPORTS.TABS.AWAITING_PAYMENT', 'Awaiting payment'), name: 'awaiting-payment' },
          { title: tr('FRONTEND.REPORTS.TABS.DRAFT_REPORTS', 'Draft reports'), name: 'draft' },
          { title: tr('FRONTEND.REPORTS.TABS.RETURNED_REPORTS', 'Returned reports'), name: 'returned' },
          { title: tr('FRONTEND.REPORTS.TABS.CONCLUDED', 'Concluded'), name: 'concluded' }
        ]
      }
      break

    case 'OWNER':
    case 'ADMINISTRATOR':
      return [
        {
          title: tr('FRONTEND.REPORTS.TABS.ALL_AWAITING_APPROVAL', 'All awaiting approval'),
          name: 'all-awaiting-approval'
        },
        { title: tr('FRONTEND.REPORTS.TABS.YOUR_ACTION_NEEDED', 'Your action needed'), name: 'your-action-needed' },
        { title: tr('FRONTEND.REPORTS.TABS.YOUR_REPORTS', 'Your reports'), name: 'your-reports' },
        { title: tr('FRONTEND.REPORTS.TABS.AWAITING_PAYMENT', 'Awaiting payment'), name: 'awaiting-payment' },
        { title: tr('FRONTEND.REPORTS.TABS.CONCLUDED', 'Concluded'), name: 'concluded' }
      ]
  }

  return []
}

export const getExpenseReportsTabStates = (tab: string): string[] => {
  switch (tab as ExpenseReportsTab) {
    case 'all-awaiting-approval':
      return ['EDIT', 'WAITING_APPROVAL', 'WAITING_FINANCE_APPROVAL']
    case 'awaiting-approval':
      return ['WAITING_APPROVAL', 'WAITING_FINANCE_APPROVAL']
    case 'awaiting-payment':
      return ['APPROVED']
    case 'concluded':
      return ['COMPLETELY_PAID', 'PARTIALLY_PAID', 'UNPAID', 'REJECTED']
    case 'draft':
      return ['NEW']
    case 'returned':
      return ['EDIT']
    default:
      return []
  }
}

/*
  | "NEW"
	| "EDIT"
	| "WAITING_APPROVAL"
	| "WAITING_FINANCE_APPROVAL"
	| "APPROVED"
	| "REJECTED"
	| "COMPLETELY_PAID"
	| "PARTIALLY_PAID"
	| "UNPAID";
*/

const fieldsToOmit = new Set(['owner', 'state'])

const isValidField = (key: string, value: any) => {
  const isDateValid = value instanceof Date && !Number.isNaN(value.valueOf())
  return (isValidString(value) || isDateValid) && !fieldsToOmit.has(key)
}

export const getExpenseReportsFilterCount = (filters: UseFilterOutput): number => {
  return Object.entries(filters.filterValues).reduce(
    (count, [key, value]) => count + (isValidField(key, value) ? 1 : 0),
    0
  )
}
